import { Skeleton } from "@/components/ui/skeleton";

export const AcademySkeleton = () => {
  return (
    <main className="flex-1 p-3 md:p-6 pb-16 flex justify-center overflow-y-auto">
      <div className="w-full max-w-[1200px] space-y-6 pb-16" role="status" aria-label="Ładowanie akademii">
        {/* Hero card */}
        <div className="rounded-2xl border border-border/50 p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <Skeleton className="w-32 h-32 md:w-40 md:h-40 rounded-xl flex-shrink-0" />
            <div className="flex-1 space-y-3 text-center md:text-left">
              <Skeleton className="h-7 w-48 mx-auto md:mx-0" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          </div>
        </div>

        {/* Module cards */}
        <div className="space-y-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="rounded-2xl border border-border/50 p-5 flex items-center gap-4">
              <Skeleton className="w-10 h-10 rounded-xl flex-shrink-0" />
              <div className="flex-1 space-y-1.5">
                <Skeleton className="h-4 w-48" />
                <Skeleton className="h-3 w-64" />
              </div>
              <Skeleton className="h-4 w-16" />
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};
